(function () {
  'use strict';

  if (window.__milanoCartCheckoutGuardLoaded) return;
  window.__milanoCartCheckoutGuardLoaded = true;

  function resetForm(form) {
    if (!form) return;
    form.removeAttribute('data-mw-checkout-submitting');
    var button = form.querySelector('[data-cro-checkout-cta]');
    if (!button) return;
    button.classList.remove('is-loading');
    button.removeAttribute('aria-busy');
    button.removeAttribute('data-mw-checkout-submitting');
  }

  function bindForm(form) {
    if (!form || form.getAttribute('data-mw-checkout-guard-bound') === 'true') return;
    form.setAttribute('data-mw-checkout-guard-bound', 'true');

    form.addEventListener('submit', function (event) {
      var submitter = event.submitter || form.querySelector('[data-cro-checkout-cta]');
      if (!submitter || !submitter.matches || !submitter.matches('[data-cro-checkout-cta]')) return;

      // The theme's optional acceptance guard owns the error state. Do not show
      // a loading state when it intentionally keeps the customer in the drawer.
      var terms = form.querySelector('[data-cart-acceptance-checkbox]');
      if (terms && !terms.checked) return;

      if (form.getAttribute('data-mw-checkout-submitting') === 'true') {
        event.preventDefault();
        return;
      }

      form.setAttribute('data-mw-checkout-submitting', 'true');
      submitter.setAttribute('data-mw-checkout-submitting', 'true');
      submitter.setAttribute('aria-busy', 'true');
      submitter.classList.add('is-loading');
    });
  }

  function bindAll() {
    var forms = document.querySelectorAll('form[data-cart-form]');
    for (var i = 0; i < forms.length; i++) bindForm(forms[i]);
  }

  function resetAll() {
    var forms = document.querySelectorAll('form[data-cart-form]');
    for (var i = 0; i < forms.length; i++) resetForm(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }

  document.addEventListener('theme:cart:refresh', function () {
    resetAll();
    bindAll();
  });
  document.addEventListener('shopify:section:load', bindAll);
  window.addEventListener('pageshow', function (event) {
    if (event && event.persisted) resetAll();
  });
})();
